module.exports = " <pre>{{info}}</pre> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/Info.vue
// module id = 146
// module chunks = 0